import { useState } from "react";
import { Icon } from "../../Component";

const Textarea = ({
  id,
  label,
  required,
  autoComplete = "off",
  name,
  disabled,
  defaultValue,
  onChange,
  className,
  page,
  register = function () { },
  errors,
  capture,
  requiredMessage,
  display,
  placeholder,
  min,
  max,
  height,
  width,
  value,
  onInputCapture,
  sub
}) => {
  return (
    <div className="form-group">
      {label && (
        <>
          <label className="form-label" htmlFor={id}>
            {label}
            {requiredMessage && <span className="text-danger">*</span>}
          </label>
          {sub && <span className="form-note mb-1">{sub}</span>}
        </>
      )}
      <div className="form-control-wrap">
        <textarea
          defaultValue={defaultValue}
          min={min}
          max={max}
          capture={capture}
          id={id}
          value={value}
          name={name}
          disabled={disabled}
          onChange={onChange}
          style={{
            width: width,
            height: height || "150px", // Provide a default height for textarea
            display: display === "none" ? "none" : "",
            paddingLeft: "10px",
          }}
          onInputCapture={onInputCapture}
          {...register(name, typeof requiredMessage === "string" ? { required: requiredMessage } : requiredMessage)}
          autoComplete={autoComplete}
          placeholder={placeholder}
          className={"form-control " + className}
        />
        {errors && errors[name] && <p className="invalid">{errors[name].message}</p>}
      </div>
    </div>
  );
};

export default Textarea;